import { Route } from 'react-router-dom';
import { ristourneSchema } from './ristourne';
import Main from '@app/main/tables/Main';

/**
 * Routes configurées pour le module Ristourne
 */
const RistourneRoutes = [
    // Route de liste (principale)
    <Route
        key="ristournes-list"
        path="ristournes"
        element={<Main key="ristournes-main" pageConfig={ristourneSchema} />}
    />,
];

export default RistourneRoutes;
